import React, { useState, useEffect } from 'react';
import './App.css';
import './a11y.css'; // Import accessibility styles
import About from './Components/About/About';
import Contacts from './Components/Contacts/Contacts';
import Footer from './Components/Footer/Footer';
import Header from './Components/Header/Header';
import Home from './Components/Home/Home';
import Projects from './Components/Projects/Projects';
import Qualifications from './Components/Qualifications/Qualifications';
import ScrollUp from './Components/ScrollUp/ScrollUp';
import Skills from './Components/Skills/Skills';
import ThemeToggle from './Components/ThemeToggle/ThemeToggle';
import { BackgroundAudio } from './Components/SoundManager/SoundManager';
import LoadingSpinner from './Components/LoadingSpinner/LoadingSpinner';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <a href="#home" className="skip-to-content">Skip to content</a>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <Header />
          <ThemeToggle />
          <BackgroundAudio />

          <main className='main' id="main-content">
            <Home />
            <About />
            <Skills />
            <Qualifications />
            <Projects />
            <Contacts />
          </main>
          
          <Footer />
          <ScrollUp />
        </>
      )}
    </>
  );
}

export default App;
